<template>
  <div class="enterprise-card">
    <h2 class="mb-[12px] mt-0 font-[600]">{{ data.title }}</h2>
    <p class="mb-[32px] mt-0 font-[500]">{{ data.desc }}</p>

    <CarouselList class="enterprise-card-carousel" :total="data.list.length">
      <SwiperSlide v-for="item in data.list" :key="item.title">
        <BaseCard
          :data="formatCard(item as IGetCaseItem)"
          :link="{
            name: PageKey.CASE_DETAIL,
            params: { id: (item as IGetCaseItem).id },
          }"
        >
          <template #title>
            <template v-if="cardName(item.title).length > 1">
              <span class="main-title font-[600]">
                {{ cardName(item.title)[0] }}
              </span>
              <span class="sub-title"> | {{ cardName(item.title)[1] }} </span>
            </template>
            <template v-else>
              {{ item.title }}
            </template>
          </template>
        </BaseCard>
      </SwiperSlide>
    </CarouselList>
  </div>
</template>

<script lang="ts" setup>
import { SwiperSlide } from 'swiper/vue'
import CarouselList from '../carousel-list.vue'
import type { ScenariosConfigDataCard } from '~/api/interface'
import type { IGetCaseItem } from '~/api/interface/publicize'
import BaseCard, { type IBaseCardData } from '~/components/content/baseCard.vue'
import { PageKey } from '~/constants/page'

interface CardProps {
  data: ScenariosConfigDataCard
}

defineProps<CardProps>()

const cardName = (name: string) => name.split('丨')

const formatCard = (card: IGetCaseItem) => {
  return {
    title: card.title,
    cover_image_url: card.cover_image_url,
    is_new: card.is_new,
  } as IBaseCardData
}
</script>

<style lang="scss" scoped>
h2 {
  font-size: 24px;
  font-weight: 600;
  line-height: 36px;
  text-align: center;
}

.enterprise-card-carousel {
  width: 1200px;
  margin: 0 auto;
}

p {
  font-size: 14px;
  line-height: 20px;
  width: 100%;
  font-weight: 600;
  text-align: center;
  color: var(--text-1-60);
}
</style>
